/**
 * Created by Ning Jiang on 5/13/2019.
 */

import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {
    IScatterAttentionConfig,
    ScatterAttentionController
} from "@nolimitcity/slot-game/bin/game/reelstoppresentation/scatterattention/ScatterAttentionController";
import {Timeline, TimelineLite} from "gsap";
import {PixiesVsPiratesGameConfig} from "../../PixiesVsPiratesGameConfig";
import {PixiesVsPiratesSoundConfig} from "../../PixiesVsPiratesSoundConfig";
import {PixiesVsPiratesParsedGameData} from "../../server/parseddata/PixiesVsPiratesParsedGameData";

export class PPScatterAttentionController extends ScatterAttentionController {

    private _isFreespinMode:boolean;

    constructor(index:number, config:IScatterAttentionConfig) {
        super(index, config);
    }

    protected parseFeatureGameData(data:PixiesVsPiratesParsedGameData):void {
        super.parseFeatureGameData(data);
        this._isFreespinMode = data.mode === GameMode.FREESPIN;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(this._isFreespinMode) {
            this.dispatchCompleteEvent(data.reelId);
            return;
        }

        super.onReelBounce(data);
    }

    protected playAttentionAnimation(data:IReelStoppedData):void {
        this.playSymbolAttentionAnimation(data.reelId);
        SlotGame.sound.playEffect((<any>PixiesVsPiratesSoundConfig)[`SCATTER_LANDING_${this._scatterCounter}`]);
        this.dispatchCompleteEvent(data.reelId);
    }

    protected playWinAttentionAnimation(data:IReelStoppedData):void {
        const timeline:TimelineLite = new TimelineLite({paused : true});
        for(let i:number = 1; i < 5; i++) {
            timeline.add(() => this.playSymbolAttentionAnimation(i));
        }
        timeline.add(() => this.dispatchCompleteEvent(data.reelId));
        timeline.play();
    }

    private playSymbolAttentionAnimation(reelId:number):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        const symbolId:number = this._scatterPositions[reelId];
        const scatter:StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
        if(scatter !== null) {
            scatter.parent.addChild(scatter);
            timeline.add([
                scatter.changeState({
                    state : PixiesVsPiratesGameConfig.instance.SYMBOL_STATES.attention,
                    replay : true,
                    fadeInDuration : 0.5
                }),
                () => SlotGame.sound.playEffect(PixiesVsPiratesSoundConfig.SCATTER_HIGHLIGHT)
            ]);
        }
        return timeline;
    }
}